import { type DatabaseFieldType } from '@databases/types/database';
import React, { type FunctionComponent } from 'react';
import styled from 'styled-components';

import { type ViewComponentProps } from './types';

const Container = styled.span`
  white-space: pre-line;
`;

const TextValueView: FunctionComponent<ViewComponentProps<DatabaseFieldType.TEXT>> = ({
  value,
}) => {
  return <Container>{value}</Container>;
};

export default TextValueView;
